var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author Hyeongjin Oh
 * @contact hjoh@detech.co.kr
 * @date 2022-07-13
 * @brief EHP 시험성적서 컴포넌트
 *
 ********************************************************************/
import React, { useState, useEffect, useRef } from "react";
//
import { useAsync } from "react-async";
import axios from 'axios';
// recoli & state
import { useRecoilValue, useRecoilState } from "recoil";
import { userInfoLoginState, } from '../../../recoil/userState';
import { itemReportListState } from "../../../recoil/reportViewState";
//
import { useTrans } from "../../../utils/langs/useTrans";
//utils
import clog from "../../../utils/logUtils";
import * as CONST from "../../../utils/Const";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
import * as FILEUTILS from "../../../utils/file/fileUtil";
//압축 다운로드
import JSZip from "jszip";
import Scan from "../../common/camera/Scan";
/*
import QrLayoutPopup from "./QrLayoutPopup";
import Guid from "./Guid";
import Uuid from "./Uuid";
import axios from "axios";
*/
/**
 * @brief EHP 시험성적서 컴포넌트, 반응형 동작
 * @param -
 * @returns react components
 */
function ItemReportView(props) {
    //trans
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [itemReportList, setItemReportList] = useRecoilState(itemReportListState);
    //props
    const { company, zone, subZone, room, spg } = props.curTreeData;
    const [curZone, setCurZone] = useState(null);
    //zoneId: (company.companyId < 0) ? null : company.companyName + ":" + zone.zoneName, //"LS일렉트릭:안양", // 변경 예정
    const [zoneList, setZoneList] = useState([]);
    //tab
    const [isNoData, setIsNoData] = useState(false);
    function handleNodata(pageInfo) {
        if (pageInfo.totalElements <= 0) {
            setIsNoData(true);
        }
        else {
            setIsNoData(false);
        }
    }
    //const [listInit, setListInit] = useState(false);
    const [itemList, setItemList] = useState([]);
    const [pageInfo, setPageInfo] = useState({ "size": 20, "totalElements": 0, "totalPages": 0, "number": 0 });
    const [tabPos, setTabPos] = useState(0);
    const tabRef = useRef(null);
    const listSize = 10;
    const [tabMove, setTabMove] = useState(null);
    // searchCombo
    /* by sjpark 20220929 기기 명 -> 모델 명, 제조번호 -> 시리얼 번호*/
    const searchFieldList = [
        { "id": 0, "dispTxt": t("FIELD.모델명"), "dispVal": "itemName", },
        { "id": 1, "dispTxt": t("FIELD.시리얼번호"), "dispVal": "serialNo", },
        /*
        { "dispTxt": "모델 명", "paramVal": "itemName", "isSelect": true },
        { "dispTxt": "시리얼 번호", "paramVal": "serialNo", "isSelect": false },
        */
    ];
    const [searchField, setSearchField] = useState(searchFieldList[0]);
    // qr hook
    const [video, setVideo] = useState(false);
    const [serialD, setSerialD] = useState("");
    const [reportList, setReportList] = useState([]);
    const [qrSerial, setQrSerial] = useState([]);
    const [qrTimeOut, setQrTimeOut] = useState(false);
    const [typePop, setTypePop] = useState("");
    //mobile
    const mobileRef = useRef(null); // Mobile Check용
    const [isMobile, setIsMobile] = useState(false);
    useEffect(() => {
        function handleResize() {
            if (CUTIL.isnull(mobileRef))
                return;
            const mobileTag = mobileRef.current;
            if ((mobileTag.clientHeight <= 0) && (mobileTag.clientWidth <= 0)) {
                setIsMobile(true);
            }
            else {
                setIsMobile(false);
            }
        }
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    useEffect(() => {
        if (CUTIL.isnull(mobileRef))
            return;
        const mobileTag = mobileRef.current;
        if (!CUTIL.isnull(mobileTag)) {
            if ((mobileTag.clientHeight <= 0) && (mobileTag.clientWidth <= 0)) {
                setIsMobile(true);
            }
            else {
                setIsMobile(false);
            }
        }
    }, []);
    ///
    const { data: data, error, isLoading, reload, run } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        //deferFn: HttpUtil.Http,
        httpMethod: "GET",
        appPath: "/api/v2/product/zone/company",
        appQuery: {},
        userToken: userInfo.loginInfo.token,
    });
    useEffect(() => {
        if (data && (data.codeNum == CONST.API_200)) {
            if (curZone == null) {
                setCurZone(data.body[0]);
            }
            setZoneList(data.body);
        }
    }, [data]);
    // option 선택 시  값 변경 액션
    function selectTabOption(optionElement) {
        const selectBox = optionElement.closest(".select");
        const selectedElement = selectBox.querySelector(".selected-value ");
        selectedElement.textContent = optionElement.textContent;
        var zoneInfo = optionElement.getAttribute("data-value");
        //selectedElement.setAttribute("data-value", optionElement.getAttribute("data-value"))
        selectedElement.setAttribute("data-value", zoneInfo);
        clog("OPT VAL : " + optionElement.value);
        setCurZone(JSON.parse(zoneInfo)); // 탭 또는 모바일 경우
        resetSearchParams();
    }
    // option 선택 시  값 변경 액션
    function selectOptionSearchField(optionElement) {
        const selectBox = optionElement.closest(".select");
        const selectedElement = selectBox.querySelector(".selected-value ");
        selectedElement.textContent = optionElement.textContent;
        var optionData = optionElement.getAttribute("data-value");
        setSearchField(JSON.parse(optionData));
    }
    //
    function onClickTab(e) {
        var actTag = (e.target.tagName === "DIV") ? e.target : e.currentTarget;
        var zoneInfo = actTag.getAttribute("data-value");
        setCurZone(JSON.parse(zoneInfo));
        resetSearchParams();
    }
    const [reportLoading, setReportLoading] = useState(false);
    // innerHTML 사용시 re-rendering에 문제가 발생함. 강제 처리 -_-;
    const onloadRef = useRef(null); // Mobile Check용
    function initTrRendering() {
        var trClicks = document.querySelectorAll(".tr__click");
        for (var i = 0; i < trClicks.length; i++) {
            var clickTag = trClicks[i];
            clickTag.classList.remove("open");
        }
        var trDetails = document.querySelectorAll(".tr__detail");
        for (var i = 0; i < trDetails.length; i++) {
            var detailTag = trDetails[i];
            //detailTag.style.setProperty("display", "table-row");        
            detailTag.innerHTML = "";
        }
    }
    useEffect(() => {
        if (onloadRef) {
            clog("XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX");
            initTrRendering();
            /*
            var trClicks = document.querySelectorAll(".tr__click");
            for (var i = 0; i < trClicks.length; i++) {
              var clickTag = trClicks[i];
              clickTag.classList.remove("open");
            }
            var trDetails = document.querySelectorAll(".tr__detail");
            for (var i = 0; i < trDetails.length; i++) {
              var detailTag = trDetails[i];
              //detailTag.style.setProperty("display", "table-row");
              detailTag.innerHTML = "";
            }
            */
        }
    }, [onloadRef, curZone]);
    //
    const [winFilter, setWinFilter] = useState(false);
    const [searchFilterList, setSearchFilterList] = useState([]);
    const [filterList, setFilterList] = useState([
        { fname: "전체", checked: true },
        { fname: "배전반", checked: false },
        { fname: "유입식TR", checked: false },
        { fname: "ACB", checked: false },
        { fname: "GIS", checked: false },
        { fname: "MoldTR", checked: false },
        { fname: "VCB", checked: false },
    ]);
    useEffect(() => {
        setTabMove(tabRef.current);
    });
    // 이전&다음 버튼 이벤트
    function onClickTabNext(idx) {
        setTabPos(idx + 1);
        if ((idx + 1) < zoneList.length) {
            //setCurZone(zoneList[idx + 1]);
            //resetSearchParams();
        }
    }
    function onClickTabPrev(idx) {
        setTabPos(idx - 1);
        if ((idx - 1) >= 0) {
            //setCurZone(zoneList[idx - 1]);
            //resetSearchParams();
        }
    }
    function searchFileter(e) {
        var curTag = e.target;
        if ((curTag.tagName === "A") || (curTag.tagName === "LI"))
            return;
        setWinFilter(!winFilter);
        /*
        var curTag = e.target;
        var filterDiv = curTag.closest(".filter");
        if ( CUTIL.isnull(filterDiv) ) return;
        //toggle
        filterDiv.classList.toggle("open");
        */
    }
    function resetSearchParams() {
        setPageInfo({ "size": 20, "totalElements": 0, "totalPages": 0, "number": 0 });
        setItemList([]);
        setSearchText("");
        setSearchField(searchFieldList[0]);
        setSearchTextField({
            searchField: "",
            searchText: ""
        });
        setSearchFilterList([]);
        setFilterList(filterList.map((filter) => (filter.fname === "전체") ? Object.assign(Object.assign({}, filter), { checked: true }) : Object.assign(Object.assign({}, filter), { checked: false })));
    }
    function handleClickSearchFilter(e) {
        e.preventDefault();
        var curTag = (e.target.tagName === "A") ? e.currentTarget : e.target;
        var filterVal = curTag.getAttribute("data-value");
        if (filterVal === "전체") {
            setFilterList(filterList.map((filter) => (filter.fname === "전체") ? Object.assign(Object.assign({}, filter), { checked: !filter.checked }) : Object.assign(Object.assign({}, filter), { checked: false })));
        }
        else { // 개별
            setFilterList(filterList.map((filter) => (filter.fname === "전체") ? Object.assign(Object.assign({}, filter), { checked: false }) : (filter.fname === filterVal) ? Object.assign(Object.assign({}, filter), { checked: !filter.checked }) : filter));
        }
    }
    const [searchText, setSearchText] = useState("");
    const [searchTextField, setSearchTextField] = useState({
        searchField: null,
        searchText: null,
    });
    //
    function onClickGoSearch(e) {
        setPageInfo({ "size": 20, "totalElements": 0, "totalPages": 0, "number": 0 });
        setSearchTextField({
            searchField: searchField,
            searchText: searchText
        });
        // search시 필터 적용
        setSearchFilterList(filterList.filter((filter) => filter.checked));
    }
    function searchTextClose(e) {
        setSearchText("");
    }
    function pdfDownloadAll(e, reportList) {
        clog("IN ItemReports : pdfDownloadAll : " + reportList.length);
        let zips = new JSZip();
        let zipCnt = 0;
        // const zipFileName = "검사성적서.zip" // 최효일PM님 지시로 문구 변경 by hjo-22011014
        const zipFileName = "TestReport.zip";
        reportList.map((report) => {
            const sPos = (report.PDF_LINK.lastIndexOf('/') < 0) ? 0 : report.PDF_LINK.lastIndexOf('/');
            const ePos = (report.PDF_LINK.lastIndexOf('?') < 0) ? report.PDF_LINK.length : report.PDF_LINK.lastIndexOf('?');
            const fileName = report.PDF_LINK.substring(sPos + 1, ePos);
            const objUrl = new URL(report.PDF_LINK);
            let reportLink = report.PDF_LINK;
            // reportLink = "https://tbs1.ls-electric.com:8443"+objUrl.pathname;
            clog("URL OBJ : " + objUrl.origin + " : " + objUrl.pathname);
            clog("IN ItemReports : pdfDownloadAll : " + zipCnt + " : " + fileName + " : " + reportLink);
            axios({
                method: "GET",
                url: reportLink,
                //url: report.PDF_LINK,
                responseType: "blob",
            }).then((resp) => {
                zips.file(fileName, resp.data);
                zipCnt++;
                return zipCnt;
            }).then((zipCnt) => {
                if (zipCnt === reportList.length) {
                    //FILEUTILS.saveToFile_Chrome(fileName, response.data);
                    zips.generateAsync({ type: "blob" }).then(function (blob) {
                        FILEUTILS.saveToFile_Chrome(zipFileName, blob);
                    });
                }
            });
        });
    }
    //
    return (React.createElement(React.Fragment, null,
        React.createElement("article", { className: `box list ${(isLoading || reportLoading) ? "loading__box" : ""}` },
            React.createElement("div", { className: `box__body ${(isNoData) ? "nodata" : ""}` },
                React.createElement("section", { className: "swiper-section", style: { "cursor": "pointer" } },
                    React.createElement("div", { className: "swiper-container mySwiper" },
                        React.createElement("div", { style: { "cursor": "pointer" }, className: "swiper-wrapper" }, zoneList.filter((tzone, idx) => ((idx < zoneList.length)) && (idx >= tabPos)).map((tzone, idx) => (React.createElement("div", { ref: tabRef, key: tzone.zoneid + "_" + idx, className: `swiper-slide tab ${(tzone.zoneId == curZone.zoneId) ? "on" : ""}`, "data-value": JSON.stringify(tzone), onClick: (e) => (tzone.zoneId !== curZone.zoneId) && onClickTab(e) },
                            React.createElement("p", null, tzone.company.companyName + " " + tzone.zoneName)))))),
                    (zoneList.length >= 5) &&
                        React.createElement("div", { className: "swiper-navigation" },
                            (tabPos > 0)
                                ? React.createElement("div", { className: "swiper-button-prev", onClick: (e) => onClickTabPrev(tabPos) })
                                : React.createElement("div", { className: "swiper-button-prev  swiper-button-disabled", "aria-disabled": true }),
                            ((tabPos + 3) < zoneList.length)
                                ? React.createElement("div", { className: "swiper-button-next", onClick: (e) => onClickTabNext(tabPos) })
                                : React.createElement("div", { className: "swiper-button-next swiper-button-disabled", "aria-disabled": true }))),
                React.createElement("div", { className: "d-sm-tab" },
                    React.createElement("div", { className: "select", onClick: (e) => CUTIL.onClickSelect(e, selectTabOption) },
                        React.createElement("div", { className: "selected" },
                            React.createElement("div", { className: "selected-value" }, (curZone) && curZone.company.companyName + " " + curZone.zoneName),
                            React.createElement("div", { className: "arrow" })),
                        React.createElement("ul", null, zoneList.map((tzone, idx) => (React.createElement("li", { key: tzone.zoneid + "_m_" + idx, className: `option tab ${(curZone.zoneId === tzone.zoneId) ? "on" : ""}`, "data-value": JSON.stringify(tzone) }, tzone.company.companyName + " " + tzone.zoneName)))))),
                React.createElement("div", { id: "tab-1", className: "tabcontent current" },
                    React.createElement("div", { className: "tabcontent__top" },
                        React.createElement("p", { className: "tabcontent__title" },
                            React.createElement("span", null,
                                "Test Report ",
                                t("LABEL.조회")),
                            React.createElement("button", { type: "button", className: "btn btn-qr js-open", "data-pop": "pop-qr", onClick: (e) => CUTIL.jsopen_Popup(e) },
                                React.createElement("span", { "data-pop": "pop-qr" }, "QR"))),
                        React.createElement("div", { className: "search__inline" },
                            React.createElement("div", { id: "win_filter", className: `filter js-open-m ${(winFilter) ? "open" : ""}`, "data-pop": "pop-filter", onClick: (e) => { (isMobile) ? CUTIL.jsopen_m_Popup(e) /*mobilePopup(e)*/ : searchFileter(e); } },
                                React.createElement("p", { className: "title" },
                                    React.createElement("span", null, t("LABEL.필터"))),
                                React.createElement("div", { className: "filter__select" },
                                    React.createElement("div", { className: "filter__type" },
                                        React.createElement("ul", { className: "type__cont" }, filterList.map((filter, idx) => (React.createElement("li", { key: "filter_" + idx, className: (filter.checked) ? "on" : "", "data-value": filter.fname, onClick: (e) => handleClickSearchFilter(e) },
                                            React.createElement("a", { href: "#" }, filter.fname)))))))),
                            React.createElement("div", { className: "inline right" },
                                React.createElement("div", { className: "search-small js-open-m", "data-pop": "pop-search-small", onClick: (e) => { (isMobile) ? CUTIL.jsopen_m_Popup(e) /*mobilePopup(e)*/ : ""; } },
                                    React.createElement("p", { className: "title" },
                                        React.createElement("span", null, t("LABEL.검색"))),
                                    React.createElement("div", { className: "search__cont" },
                                        React.createElement("div", { ref: mobileRef, className: "searcharea" },
                                            React.createElement("div", { className: "searchinput" },
                                                React.createElement("div", { className: "select", onClick: (e) => CUTIL.onClickSelect(e, selectOptionSearchField) },
                                                    React.createElement("div", { className: "selected" },
                                                        React.createElement("div", { id: "search_selected-value", className: "selected-value" }, searchFieldList[0].dispTxt /*searchField.dispTxt*/),
                                                        React.createElement("div", { className: "arrow" })),
                                                    React.createElement("ul", null, searchFieldList.map((sf, idx) => (React.createElement("li", { key: `sf_${idx.toString()}`, className: "option", "data-value": JSON.stringify(sf) }, sf.dispTxt))))),
                                                React.createElement("div", { className: "input__direct" },
                                                    React.createElement("input", { type: "text", placeholder: t("MESSAGE.검색어를입력하세요") /*"검색어를 입력하세요"*/, value: searchText, onChange: (e) => setSearchText(e.target.value) }),
                                                    (searchText.length > 0) &&
                                                        React.createElement("button", { type: "button", className: "btn btn-delete", onClick: (e) => searchTextClose(e) },
                                                            React.createElement("span", { className: "hide" }, "\uC785\uB825 \uCC3D \uB2EB\uAE30")))),
                                            React.createElement("input", { type: "text", className: "d-sm-block-toggle", placeholder: t("MESSAGE.기기명을입력하세요"), value: searchText, onChange: (e) => setSearchText(e.target.value) }),
                                            React.createElement("button", { type: "button", className: "btn-search", onClick: (e) => onClickGoSearch(e) },
                                                React.createElement("span", null, t("LABEL.조회")))))),
                                ((filterList.filter((filter) => (filter.checked) && (filter.fname !== "전체")).length > 0) || (searchText.length > 0))
                                    ? React.createElement("button", { type: "button", className: "btn-renew", onClick: resetSearchParams },
                                        React.createElement("span", null, t("LABEL.필터초기화")))
                                    : React.createElement("button", { type: "button", className: "btn-renew", disabled: true },
                                        React.createElement("span", null, t("LABEL.필터초기화"))),
                                (itemReportList.length <= 0)
                                    ? React.createElement("button", { type: "button", className: "btn btn-filedown", disabled: true },
                                        React.createElement("span", { className: "hide" }, "\uB2E4\uC6B4\uB85C\uB4DC"))
                                    : React.createElement("button", { type: "button", className: "btn btn-filedown", onClick: (e) => { pdfDownloadAll(e, itemReportList); } },
                                        React.createElement("span", { className: "hide" }, "\uB2E4\uC6B4\uB85C\uB4DC")),
                                React.createElement("button", { type: "button", className: "btn btn-qr btn-basic mr-10 js-open", "data-pop": "pop-qr-web", onClick: (e) => CUTIL.jsopen_Popup(e) },
                                    React.createElement("span", { "data-pop": "pop-qr-web" }, t("FIELD.시리얼번호")))))),
                    (curZone) && React.createElement(ItemReportTabCont
                    //listInit={listInit}
                    , { 
                        //listInit={listInit}
                        itemList: itemList, setItemList: setItemList, pageInfo: pageInfo, setPageInfo: setPageInfo, selZone: curZone, searchFilter: searchFilterList, searchTextField: searchTextField, reportLoading: reportLoading, setReportLoading: setReportLoading, handleNodata: handleNodata }))),
            React.createElement("div", { ref: onloadRef })),
        React.createElement(SearchFilterPopup, { goSearch: onClickGoSearch, filterList: filterList, handleClickSearchFilter: handleClickSearchFilter }),
        React.createElement(SearchTextPopup, { searchFieldList: searchFieldList, searchField: searchField, setSearchField: setSearchField, searchText: searchText, setSearchText: setSearchText, 
            //handleSelect={onClickSelect}
            handleOption: selectOptionSearchField, goSearch: onClickGoSearch }),
        React.createElement(QrCodeSearchPop, { serialD: serialD, setSerialD: setSerialD, video: video, setVideo: setVideo, reportList: reportList, setReportList: setReportList, setReportLoading: setReportLoading, typePop: typePop, setTypePop: setTypePop }),
        React.createElement(QrCodeWebPop, { serialD: serialD, setSerialD: setSerialD, video: video, setVideo: setVideo, reportList: reportList, setReportList: setReportList, setReportLoading: setReportLoading, typePop: typePop, setTypePop: setTypePop }),
        React.createElement(QrReaderPop, { video: video, setVideo: setVideo, qrTimeOut: qrTimeOut, setQrTimeOut: setQrTimeOut, qrSerial: qrSerial, setQrSerial: setQrSerial }),
        React.createElement(QrScanRsultPop, { serialD: serialD, setSerialD: setSerialD, setReportList: setReportList, reportList: reportList, qrSerial: qrSerial, video: video, setVideo: setVideo, qrTimeOut: qrTimeOut, setQrTimeOut: setQrTimeOut, setQrSerial: setQrSerial, setReportLoading: setReportLoading, typePop: typePop, setTypePop: setTypePop }),
        React.createElement(QrRsultPop, { serialD: serialD, setSerialD: setSerialD, setReportList: setReportList, reportList: reportList, qrSerial: qrSerial, setVideo: setVideo, setQrSerial: setQrSerial, setReportLoading: setReportLoading, typePop: typePop, setTypePop: setTypePop })));
}
export default ItemReportView;
function ItemReportTabCont(props) {
    //trans
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    //
    const itemList = props.itemList;
    const setParentItemList = props.setItemList;
    const pageInfo = props.pageInfo;
    const setParentPageInfo = props.setPageInfo;
    const curZone = props.selZone;
    const searchFilter = props.searchFilter;
    const searchTextField = props.searchTextField;
    const reportLoading = props.reportLoading;
    const setParentReportLoading = props.setReportLoading;
    const setParentSelReports = props.setSelReports;
    const setParentNodata = props.handleNodata;
    ///
    //const [itemList, setItemList] = useState([]);
    const [searchParams, setSearchParams] = useState({});
    ///////////////////////////////////////////
    let appPath = "";
    ////////////////////////////////////////
    //page":{"size":10,"totalElements":65,"totalPages":7,"number":0}
    //appPath = 'page=' + pageInfo.number + '&size=' + pageInfo.size;
    function handleScroll(e) {
        return __awaiter(this, void 0, void 0, function* () {
            var actTag = e.target;
            if (actTag.scrollHeight >= (actTag.clientHeight + actTag.scrollTop + 2))
                return;
            if (!isLoading) {
                if (pageInfo.totalPages > pageInfo.number + 1) {
                    //clog("IN ItemReport : RESIZE : " + appPath + " : " + JSON.stringify(pageInfo));
                    let data = null;
                    data = yield HTTPUTIL.PromiseHttp({
                        "httpMethod": "GET",
                        "appPath": `/api/v2/product/company/zone/room/panel/item/testreport?page=${pageInfo.number + 1}&size=${pageInfo.size}&${appPath}`,
                        "appQuery": {},
                        userToken: userInfo.loginInfo.token,
                    });
                    if (data) {
                        if (data.codeNum === CONST.API_200) {
                            setParentPageInfo(data.data.page);
                            setParentItemList(itemList.concat(data.body));
                            //alert(`ERROR : ${cmsg.language} : ` + JSON.stringify(data.body.errorList));
                        }
                    }
                }
            }
        });
    }
    //appPath = appPath + "&zoneId=" + curZone.zoneId;
    appPath = "zoneId=" + curZone.zoneId;
    /*
    useEffect(() => {
      setParentPageInfo({ ...pageInfo, "totalElements": 0, "totalPages": 0, "number": 0 });
      setParentItemList([]);
    }, [curZone])
    */
    let strFilter = "";
    searchFilter.filter((filter) => (filter.checked === true) && (filter.fname !== "전체")).map((filter, idx) => {
        if (idx > 0)
            strFilter = strFilter + ",";
        strFilter = strFilter + filter.fname;
    });
    if (strFilter.length > 0) {
        appPath = appPath + "&spgList=" + strFilter;
    }
    useEffect(() => {
        setParentPageInfo(Object.assign(Object.assign({}, pageInfo), { "totalElements": 0, "totalPages": 0, "number": 0 }));
        setParentItemList([]);
    }, [strFilter]);
    /*
    if (searchTextField.searchText.length > 0) {
      appPath = appPath + `&${searchTextField.searchField}=` + searchTextField.searchText;
    }
    */
    //text검색
    if (searchTextField.searchField) {
        if (searchTextField.searchField.dispVal.length > 0) {
            //appPath = appPath + `&searchKind=${searchData.searchField.sfVal}&searchLike=${searchData.searchText}`;
            appPath = appPath + `&${searchTextField.searchField.dispVal}=` + searchTextField.searchText;
        }
    }
    /*
      useEffect(() => {
        if ((searchTextField.searchText)&&(searchTextField.searchText.length > 0)) {
          setParentPageInfo({ ...pageInfo, "totalElements": 0, "totalPages": 0, "number": 0 });
          setParentItemList([]);
        }
        //}, [searchTextField.searchText])
      }, [searchTextField])
    */
    ///////////////
    const listInit = props.listInit;
    //clog("IN ItemReport : INIT : " + appPath + " : " + JSON.stringify(pageInfo));
    const { data: retInit, error, isLoading, reload, run } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        //appPath: "/api/v2/product/company/zone/room/panel/item/testreport?" + appPath,
        appPath: `/api/v2/product/company/zone/room/panel/item/testreport?page=${pageInfo.number}&size=${pageInfo.size}&${appPath}`,
        appQuery: {},
        watch: appPath,
        userToken: userInfo.loginInfo.token,
    });
    useEffect(() => {
        if (retInit && (retInit.codeNum === CONST.API_200)) {
            //clog("IN ItemReport: APPPATH : RESULT : " + JSON.stringify(retInit.data.page));
            setParentNodata(retInit.data.page);
            setParentPageInfo(retInit.data.page);
            setParentItemList(retInit.body);
        }
    }, [retInit, appPath]);
    //
    function onClickItemTr(e, ord, item) {
        //setSelItem(item);
        var curTag = e.target;
        var clickTag = curTag.closest(".tr__click");
        if (CUTIL.isnull(clickTag))
            return;
        var detailTag = clickTag.nextSibling;
        if (!detailTag.classList.contains("tr__detail"))
            return;
        if (clickTag.classList.contains("open")) { // cloase
            detailTag.style.setProperty("display", "none");
            clickTag.classList.remove("open");
        }
        else { // open
            //clog("INNER HTML : " + getInnerHtml(item, detailTag.id));
            detailTag.style.setProperty("display", "table-row");
            clickTag.classList.add("open");
        }
        if (!item.serialNo) { // serialNo가 null 값 API X
            setParentItemList(itemList.map((it) => (it.itemId === item.itemId)
                ? Object.assign(Object.assign({}, it), { subObj: React.createElement(ItemReports, { item: it, dispOrd: ord, reportInfo: "", setReportLoading: setParentReportLoading, setSelReports: setParentSelReports }) }) : Object.assign({}, it)));
        }
        else {
            (() => __awaiter(this, void 0, void 0, function* () {
                if (detailTag.innerHTML.length <= 0) {
                    setParentReportLoading(true);
                    const reportInfo = yield HTTPUTIL.API_reportView(item.serialNo);
                    setParentReportLoading(false);
                    setParentItemList(itemList.map((it) => (it.itemId === item.itemId)
                        ? Object.assign(Object.assign({}, it), { subObj: React.createElement(ItemReports, { item: it, dispOrd: ord, reportInfo: reportInfo, setReportLoading: setParentReportLoading, setSelReports: setParentSelReports }) }) : Object.assign({}, it)));
                }
            }))();
        }
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("p", { className: "nodata__txt" }, t("MESSAGE.데이터를찾을수없습니다")),
        React.createElement("div", { className: "tbl-list type2", onScroll: (e) => handleScroll(e) },
            React.createElement("table", { summary: "\uAE30\uAE30 \uBA85,\uAE30\uAE30 \uC720\uD615,\uC81C\uC870\uBC88\uD638 \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC2DC\uD5D8 \uC131\uC801\uC11C \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." },
                React.createElement("caption", null, "Test Report \uB9AC\uC2A4\uD2B8"),
                React.createElement("colgroup", null,
                    React.createElement("col", { style: {} })),
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", { scope: "col", className: "d-sm-none" },
                            React.createElement("span", null, t("FIELD.기기명"))),
                        React.createElement("th", { scope: "col", className: "d-sm-none" }, t("FIELD.시리얼번호")),
                        React.createElement("th", { scope: "col", className: "d-sm-none" }, t("FIELD.모델명")),
                        React.createElement("th", { scope: "col", className: "d-sm-block" },
                            React.createElement("span", { className: "w25p" }, t("FIELD.기기명")),
                            React.createElement("span", { className: "w85p" }, t("FIELD.모델명"))))),
                React.createElement("tbody", null,
                    (itemList.length < 0) &&
                        React.createElement("tr", null,
                            React.createElement("td", null,
                                React.createElement("p", { className: "nodata__txt" }, t("MESSAGE.데이터를찾을수없습니다")))),
                    itemList.map((item, idx) => (React.createElement(React.Fragment, { key: "frm_" + idx },
                        React.createElement("tr", { key: `tr_${idx.toString()}_${searchTextField.searchText}`, id: "tr__click" + item.serialNo, 
                            //className={`tr__click ${(idx % 2 === 0) ? "" : "bg-darkwhite"} ${(selItem)?(selItem.itemId===item.itemId)?"open":"":""}`}
                            className: `tr__click ${(idx % 2 === 0) ? "" : "bg-darkwhite"}`, onClick: (e) => onClickItemTr(e, idx, item) },
                            React.createElement("td", { className: "d-sm-none" },
                                React.createElement("span", null, item.spgDtoOut.spgName)),
                            React.createElement("td", { className: "d-sm-none" }, item.serialNo),
                            React.createElement("td", { className: "d-sm-none" }, item.itemName),
                            React.createElement("td", { className: "d-sm-block firstline" },
                                React.createElement("span", { className: "w25p" }, item.spgDtoOut.spgName),
                                React.createElement("p", { className: "w85p" }, item.itemName)),
                            React.createElement("td", { className: "d-sm-block" },
                                React.createElement("span", null,
                                    t("FIELD.시리얼번호"),
                                    " : ",
                                    item.serialNo))),
                        React.createElement("tr", { key: "tr_detail_" + idx, id: "tr__detail" + item.serialNo, className: "tr__detail" }, (item.hasOwnProperty("subObj")) && item.subObj)))))))));
}
function ItemReports(props) {
    //trans
    const t = useTrans();
    //recoil
    const [itemReportList, setRecoilItemReportList] = useRecoilState(itemReportListState); // report download
    //
    const item = props.item;
    const dispOrd = props.dispOrd;
    const reportInfo = props.reportInfo;
    const reportList = reportInfo.IF_RES_DATA;
    const setParentReportLoading = props.setReportLoading;
    function downloadReport(report, callbackFunc) {
        const sPos = (report.PDF_LINK.lastIndexOf('/') < 0) ? 0 : report.PDF_LINK.lastIndexOf('/');
        const ePos = (report.PDF_LINK.lastIndexOf('?') < 0) ? report.PDF_LINK.length : report.PDF_LINK.lastIndexOf('?');
        var fileName = report.PDF_LINK.substring(sPos + 1, ePos);
        clog("IN REPORT VIEW : downloadReport : " + fileName + " : " + sPos + " : " + ePos);
        callbackFunc(true); // 다운로드 로딩 중 표시
        HTTPUTIL.fileDownload(fileName, encodeURI(report.PDF_LINK));
        callbackFunc(false);
    }
    function handleSelReports(e, itemReport) {
        var isChecked = e.target.checked;
        //setParentSelReports(isChecked, itemReport);
        clog("IN ITEMREPORT : handleSelReports : " + JSON.stringify(itemReport));
        if (isChecked) {
            setRecoilItemReportList([...itemReportList, itemReport]);
        }
        else {
            setRecoilItemReportList(itemReportList.filter((sel => sel.itemReportId !== itemReport.itemReportId)));
        }
    }
    function handleAllCheck(e) {
        var isChecked = e.target.checked;
        if (CUTIL.isnull(reportList))
            return;
        let exReportList = itemReportList;
        reportList.map((report, ridx) => {
            exReportList = exReportList.filter((crp) => crp.itemReportId !== `${item.itemId}_${report.REPORT_NO}`);
        });
        if (isChecked) {
            reportList.map((report) => {
                exReportList.push(Object.assign(Object.assign({}, report), { "itemReportId": `${item.itemId}_${report.REPORT_NO}` })); // 제외된 항목
            });
        }
        setRecoilItemReportList(exReportList);
    }
    function handleAllCheckOLD(e) {
        var isChecked = e.target.checked;
        if (CUTIL.isnull(reportList))
            return;
        if (isChecked) {
            reportList.map((report) => {
                const exList = itemReportList.filter((sel => sel.itemReportId !== `${item.itemId}_${report.REPORT_NO}`));
                setRecoilItemReportList([...exList, Object.assign(Object.assign({}, report), { "itemReportId": `${item.itemId}_${report.REPORT_NO}` })]);
            });
        }
        else {
            reportList.map((report) => {
                setRecoilItemReportList(itemReportList.filter((sel => sel.itemReportId !== `${item.itemId}_${report.REPORT_NO}`)));
            });
        }
    }
    const isAllCheck = () => {
        //clog("IN ISALLCHECK : " + JSON.stringify(reportList));
        if (CUTIL.isnull(reportList))
            return false;
        let cnt = 0;
        reportList.map((report) => {
            cnt = cnt + itemReportList.filter((sel => sel.itemReportId === `${item.itemId}_${report.REPORT_NO}`)).length;
        });
        return (cnt === reportList.length) ? true : false;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(React.Fragment, null,
            React.createElement("td", { colSpan: 3 },
                React.createElement("div", { className: "tbl-list type2" },
                    React.createElement("table", { summary: "\uD30C\uC77C \uBA85,\uC0DD\uC131\uC77C,\uCCA8\uBD80 \uD30C\uC77C \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC131\uC801\uC11C \uD30C\uC77C \uC0C1\uC138 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." },
                        React.createElement("caption", null, "\uC131\uC801\uC11C \uD30C\uC77C \uC0C1\uC138 \uB9AC\uC2A4\uD2B8"),
                        React.createElement("colgroup", null,
                            React.createElement("col", { style: {} })),
                        React.createElement("thead", null,
                            React.createElement("tr", null,
                                React.createElement("th", { scope: "col", className: "w20" },
                                    React.createElement("input", { type: "checkbox", id: `chk_${item.itemId}_all`, onChange: (e) => handleAllCheck(e), checked: isAllCheck(), disabled: (reportList == null) ? true : false }),
                                    React.createElement("label", { htmlFor: `chk_${item.itemId}_all` },
                                        React.createElement("span", { className: "hide" }, "\uC120\uD0DD"))),
                                React.createElement("th", { scope: "col" }, t("FIELD.파일명")),
                                React.createElement("th", { scope: "col" }, t("FIELD.생성일")),
                                React.createElement("th", { scope: "col", className: "txt-center" }, t("FIELD.첨부파일")))),
                        React.createElement("tbody", null,
                            (reportList == null) &&
                                React.createElement("tr", { key: "report_null" },
                                    React.createElement("td", { className: "d-sm-none w20" },
                                        React.createElement("p", { className: "icon-no ml-m10" },
                                            React.createElement("span", { className: "hide" }, "\uD30C\uC77C\uC5C6\uC74C"))),
                                    React.createElement("td", { className: "d-sm-none" }, t("MESSAGE.등록된성적서가없습니다")),
                                    React.createElement("td", { className: "d-sm-none" }, "-"),
                                    React.createElement("td", { className: "d-sm-block" },
                                        React.createElement("span", null, t("MESSAGE.등록된성적서가없습니다")),
                                        React.createElement("span", null, "-")),
                                    React.createElement("td", { className: "btn__tdarea" },
                                        React.createElement("p", { className: "icon-no gray" },
                                            React.createElement("span", { className: "hide" }, "\uD30C\uC77C\uC5C6\uC74C")))),
                            (reportList) && reportList.map((report, idx) => (React.createElement("tr", { key: "report_" + idx },
                                React.createElement("td", { className: "d-sm-none w20" },
                                    React.createElement("input", { type: "checkbox", id: `chk_${item.itemId}_${idx.toString()}`, onChange: (e) => handleSelReports(e, Object.assign(Object.assign({}, report), { "itemReportId": `${item.itemId}_${report.REPORT_NO}` })), checked: (itemReportList.filter((sel) => sel.itemReportId === `${item.itemId}_${report.REPORT_NO}`).length > 0) ? true : false }),
                                    React.createElement("label", { htmlFor: `chk_${item.itemId}_${idx.toString()}` },
                                        React.createElement("span", { className: "hide" }, "\uC120\uD0DD"))),
                                React.createElement("td", { className: "d-sm-none" },
                                    report.TYPE,
                                    " "),
                                React.createElement("td", { className: "d-sm-none" }, report.CREATION_DATE.substring(0, 4) + "-" + report.CREATION_DATE.substring(4, 6) + "-" + report.CREATION_DATE.substring(6, 8)),
                                React.createElement("td", { className: "d-sm-block" },
                                    React.createElement("span", null, report.TYPE),
                                    React.createElement("span", null, report.CREATION_DATE.substring(0, 4) + "-" + report.CREATION_DATE.substring(4, 6) + "-" + report.CREATION_DATE.substring(6, 8))),
                                React.createElement("td", { className: "btn__tdarea" }, (report.PDF_LINK == null)
                                    ? React.createElement("button", { type: "button", className: "btn btn-file", disabled: true },
                                        React.createElement("span", { className: "hide" }, "\uCCA8\uBD80 \uD30C\uC77C"))
                                    : React.createElement("a", { href: report.PDF_LINK, target: "_blank", rel: 'noreferrer' },
                                        React.createElement("button", { type: "button", className: "btn btn-file" },
                                            React.createElement("span", { className: "hide" }, "\uCCA8\uBD80 \uD30C\uC77C"))))))))))))));
}
///////////////////pop-up
function SearchFilterPopup(props) {
    //trans
    const t = useTrans();
    //props
    const filterList = props.filterList;
    const handleSearchFilter = props.handleClickSearchFilter;
    const goSearch = props.goSearch;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "pop-filter", className: "popup-layer js-layer layer-out hidden page-detail page-report" },
            React.createElement("div", { className: "popup__head" },
                React.createElement("h1", { className: "icon-filter" }, t("LABEL.필터")),
                React.createElement("button", { className: "btn btn-close js-close" },
                    React.createElement("span", { className: "hide" }, "\uB2EB\uAE30"))),
            React.createElement("div", { className: "popup__body" },
                React.createElement("div", { className: "filter__select" },
                    React.createElement("div", { className: "filter__type" },
                        React.createElement("p", { className: "tit" }, t("LABEL.기기유형")),
                        React.createElement("ul", { className: "type__cont" }, filterList.map((filter, idx) => (React.createElement("li", { key: "mfilter_" + idx, className: (filter.checked) ? "on" : "", "data-value": filter.fname, onClick: (e) => handleSearchFilter(e) },
                            React.createElement("a", { href: "#" }, filter.fname)))))))),
            React.createElement("div", { className: "popup__footer" },
                React.createElement("button", { type: "button", className: "bg-gray js-close" },
                    React.createElement("span", null, t("LABEL.취소"))),
                React.createElement("button", { type: "button", className: "js-close", onClick: (e) => goSearch(e) },
                    React.createElement("span", null, t("LABEL.적용")))))));
}
function SearchTextPopup(props) {
    //trans
    const t = useTrans();
    //props
    const searchFieldList = props.searchFieldList;
    const searchField = props.searchField;
    const setParentSearchField = props.setSearchField;
    const searchText = props.searchText;
    const setParentSearchText = props.setSearchText;
    //const handleSelect = props.handleSelect;
    //const handleOption = props.handleOption;
    const goSearch = props.goSearch;
    // option 선택 시  값 변경 액션
    function selectOptionSearchField(optionElement) {
        const selectBox = optionElement.closest(".select");
        const selectedElement = selectBox.querySelector(".selected-value ");
        selectedElement.textContent = optionElement.textContent;
        var optionData = optionElement.getAttribute("data-value");
        clog("selectOptionSearchField : pop-up" + " : " + optionData);
        //selectedElement.setAttribute("data-value", optionElement.getAttribute("data-value"))
        //selectedElement.setAttribute("data-value", optionData);
        setParentSearchField(JSON.parse(optionData));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "pop-search-small", className: "popup-layer js-layer layer-out hidden page-detail page-report" },
            React.createElement("div", { className: "popup__head" },
                React.createElement("h1", { className: "icon-search" }, t("LABEL.검색")),
                React.createElement("button", { className: "btn btn-close js-close" },
                    React.createElement("span", { className: "hide" }, "\uB2EB\uAE30"))),
            React.createElement("div", { className: "popup__body" },
                React.createElement("div", { className: "form__input mb-0" },
                    React.createElement("div", { className: "select", onClick: (e) => CUTIL.onClickSelect(e, selectOptionSearchField) },
                        React.createElement("div", { className: "selected" },
                            React.createElement("div", { id: "msearch_selected-value", className: "selected-value", "data-value": "itemName" }, searchFieldList[0].dispTxt),
                            React.createElement("div", { className: "arrow" })),
                        React.createElement("ul", null, searchFieldList.map((sf, idx) => (React.createElement("li", { key: `sf_${idx.toString()}`, className: "option", "data-value": JSON.stringify(sf) }, sf.dispTxt))))),
                    React.createElement("input", { type: "text", placeholder: t("MESSAGE.검색어를입력하세요"), value: searchText, onChange: (e) => setParentSearchText(e.target.value) }))),
            React.createElement("div", { className: "popup__footer" },
                React.createElement("button", { type: "button", className: "bg-gray js-close" },
                    React.createElement("span", null, t("LABEL.취소"))),
                React.createElement("button", { type: "button", className: "js-close", onClick: (e) => goSearch(e) },
                    React.createElement("span", null, t("LABEL.적용")))))));
}
function QrCodeSearchPop(props) {
    //props
    const serialD = props.serialD;
    const setSerialD = props.setSerialD;
    const video = props.video;
    const setVideo = props.setVideo;
    const setReportList = props.setReportList;
    const setReportLoading = props.setReportLoading;
    const typePop = props.typePop;
    const setTypePop = props.setTypePop;
    const [errorList, setErrorList] = useState([]);
    function qrSanOpen(e) {
        CUTIL.jsopen_Popup(e);
        setVideo(true);
    }
    function handleSerialNo(e) {
        setErrorList(errorList.filter((err) => (err.field !== "report")));
        setSerialD(e.target.value);
    }
    function resultOpen(e) {
        return __awaiter(this, void 0, void 0, function* () {
            if (serialD == "") {
                setErrorList([{ field: "report", msg: "시리얼번호를 입력해주세요." }]);
            }
            else {
                setReportLoading(true);
                var btnCommentOpen = document.getElementById("pop-qr");
                var body = document.body;
                var dimm = body.querySelector(".dimm");
                if (!CUTIL.isnull(btnCommentOpen))
                    btnCommentOpen.classList.add("hidden");
                if (!CUTIL.isnull(body))
                    body.setAttribute("style", "overflow-y: hidden;");
                if (!CUTIL.isnull(dimm))
                    dimm.setAttribute("style", "z-index: 30; display: block;");
                const reportInfo = yield HTTPUTIL.API_reportView(serialD);
                setReportLoading(false);
                setReportList(reportInfo);
                setTypePop("mobile");
                CUTIL.jsopen_Popup(e);
            }
        });
    }
    function closePop(e) {
        var btnCommentOpen = document.getElementById("pop-qr");
        var body = document.body;
        var dimm = body.querySelector(".dimm");
        if (!CUTIL.isnull(btnCommentOpen))
            btnCommentOpen.classList.add("hidden");
        if (!CUTIL.isnull(body))
            body.setAttribute("style", "overflow-y: auto;");
        if (!CUTIL.isnull(dimm))
            dimm.setAttribute("style", "display: none; z-index: 11;");
        setSerialD("");
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "pop-qr", className: "popup-layer js-layer layer-out hidden page-detail page-report" },
            React.createElement("div", { className: "popup__head" },
                React.createElement("h1", null, "\uC2DC\uD5D8\uC131\uC801\uC11C \uC870\uD68C"),
                React.createElement("button", { className: "btn btn-close js-close", onClick: (e) => closePop(e) },
                    React.createElement("span", { className: "hide" }, "\uB2EB\uAE30"))),
            React.createElement("div", { className: "popup__body pb-0" },
                React.createElement("ul", { className: "form__input mb-0" },
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "QR Code"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("button", { type: "button", className: "btn-qrscan js-open", "data-pop": "pop-qr-open", onClick: (e) => qrSanOpen(e) },
                                React.createElement("span", { "data-pop": "pop-qr-open" }, "QR Code Scan")))),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uC9C1\uC811 \uC785\uB825"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("input", { type: "text", className: (errorList.filter(err => (err.field === "report")).length > 0) ? "input-error" : "", value: serialD, placeholder: "\uAE30\uAE30\uC758 \uC2DC\uB9AC\uC5BC\uBC88\uD638\uB97C \uC9C1\uC811 \uC785\uB825\uD558\uC138\uC694.", onChange: (e) => handleSerialNo(e) }))))),
            React.createElement("div", { className: "popup__footer" },
                React.createElement("button", { type: "button", className: "js-open ", "data-pop": "pop-qr-result", onClick: (e) => resultOpen(e) },
                    React.createElement("span", { "data-pop": "pop-qr-result" }, "\uD655\uC778"))))));
}
function QrCodeWebPop(props) {
    //props
    const serialD = props.serialD;
    const setSerialD = props.setSerialD;
    const video = props.video;
    const setVideo = props.setVideo;
    const setReportList = props.setReportList;
    const setReportLoading = props.setReportLoading;
    const typePop = props.typePop;
    const setTypePop = props.setTypePop;
    const [errorList, setErrorList] = useState([]);
    function handleSerialNo(e) {
        setErrorList(errorList.filter((err) => (err.field !== "report")));
        setSerialD(e.target.value);
    }
    function resultOpen(e) {
        return __awaiter(this, void 0, void 0, function* () {
            if (serialD == "") {
                setErrorList([{ field: "report", msg: "시리얼번호를 입력해주세요." }]);
            }
            else {
                setReportLoading(true);
                var btnCommentOpen = document.getElementById("pop-qr-web");
                var body = document.body;
                var dimm = body.querySelector(".dimm");
                if (!CUTIL.isnull(btnCommentOpen))
                    btnCommentOpen.classList.add("hidden");
                if (!CUTIL.isnull(body))
                    body.setAttribute("style", "overflow-y: hidden;");
                if (!CUTIL.isnull(dimm))
                    dimm.setAttribute("style", "z-index: 30; display: block;");
                const reportInfo = yield HTTPUTIL.API_reportView(serialD);
                setReportLoading(false);
                setReportList(reportInfo);
                setTypePop("web");
                CUTIL.jsopen_Popup(e);
            }
        });
    }
    function closePop(e) {
        var btnCommentOpen = document.getElementById("pop-qr-web");
        var body = document.body;
        var dimm = body.querySelector(".dimm");
        if (!CUTIL.isnull(btnCommentOpen))
            btnCommentOpen.classList.add("hidden");
        if (!CUTIL.isnull(body))
            body.setAttribute("style", "overflow-y: auto;");
        if (!CUTIL.isnull(dimm))
            dimm.setAttribute("style", "display: none; z-index: 11;");
        setSerialD("");
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "pop-qr-web", className: "popup-layer js-layer layer-out hidden page-detail page-report" },
            React.createElement("div", { className: "popup__head" },
                React.createElement("h1", null, "\uC2DC\uD5D8\uC131\uC801\uC11C \uC870\uD68C"),
                React.createElement("button", { className: "btn btn-close js-close", onClick: (e) => closePop(e) },
                    React.createElement("span", { className: "hide" }, "\uB2EB\uAE30"))),
            React.createElement("div", { className: "popup__body pb-0" },
                React.createElement("ul", { className: "form__input mb-0" },
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uC9C1\uC811 \uC785\uB825"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("input", { type: "text", className: (errorList.filter(err => (err.field === "report")).length > 0) ? "input-error" : "", value: serialD, placeholder: "\uAE30\uAE30\uC758 \uC2DC\uB9AC\uC5BC\uBC88\uD638\uB97C \uC9C1\uC811 \uC785\uB825\uD558\uC138\uC694.", onChange: (e) => handleSerialNo(e) }))))),
            React.createElement("div", { className: "popup__footer" },
                React.createElement("button", { type: "button", className: "js-open ", "data-pop": "pop-qr-result", onClick: (e) => resultOpen(e) },
                    React.createElement("span", { "data-pop": "pop-qr-result" }, "\uD655\uC778"))))));
}
function QrReaderPop(props) {
    const video = props.video;
    const setVideo = props.setVideo;
    const qrTimeOut = props.qrTimeOut;
    const setQrTimeOut = props.setQrTimeOut;
    const [errText, setErrText] = useState("");
    function qrReaderColes(e) {
        var btnCommentOpen = document.getElementById("pop-qr-open");
        var body = document.body;
        var dimm = body.querySelector(".dimm");
        if (!CUTIL.isnull(btnCommentOpen))
            btnCommentOpen.classList.add("hidden");
        if (!CUTIL.isnull(body))
            body.setAttribute("style", "overflow-y: hidden;");
        if (!CUTIL.isnull(dimm))
            dimm.setAttribute("style", "z-index: 30; display: block;");
        setVideo(false);
    }
    function qrReaderRuslt(e) {
        var btnCommentOpen = document.getElementById("pop-qr-open");
        var btnCommentClose = document.getElementById("pop-qr-result");
        var btnCommentQr = document.getElementById("pop-qr");
        var body = document.body;
        var dimm = body.querySelector(".dimm");
        if (!CUTIL.isnull(btnCommentOpen))
            btnCommentOpen.classList.add("hidden");
        if (!CUTIL.isnull(btnCommentQr))
            btnCommentQr.classList.add("hidden");
        if (!CUTIL.isnull(btnCommentClose))
            btnCommentClose.classList.remove("hidden");
        if (!CUTIL.isnull(body))
            body.setAttribute("style", "overflow-y: hidden;");
        if (!CUTIL.isnull(dimm))
            dimm.setAttribute("style", "z-index: 30; display: block;");
        setVideo(false);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "pop-qr-open", className: "popup-layer layer-out js-layer hidden page-qropen" },
            React.createElement("div", { className: "popup__body" }, (video && !errText) &&
                React.createElement(Scan, { qrSerial: props.qrSerial, setQrSerial: props.setQrSerial, qrReaderColes: qrReaderRuslt, CUTIL: CUTIL, setVideo: setVideo, setQrTimeOut: setQrTimeOut, errText: errText, setErrText: setErrText })),
            React.createElement("div", { className: "popup__footer" },
                (!errText) ?
                    React.createElement("div", { className: "qr__bottom" },
                        React.createElement("p", null, "\uD654\uBA74\uC5D0 \uC81C\uD488 QR\uCF54\uB4DC\uB97C \uB9DE\uCDB0\uC8FC\uC138\uC694."),
                        React.createElement("p", { className: "info" }, "\uC81C\uD488 \uC815\uBCF4\uB97C \uC790\uB3D9\uC73C\uB85C \uC2A4\uCE94\uD569\uB2C8\uB2E4."))
                    :
                        React.createElement("div", { className: "qr__bottom" },
                            React.createElement("p", null, "\uD574\uB2F9 \uAE30\uAE30\uC5D0\uC11C\uB294 \uC2A4\uCE94\uC774 \uBD88\uAC00\uB2A5 \uD569\uB2C8\uB2E4. "),
                            React.createElement("p", { className: "info" }, "\uBAA8\uBC14\uC77C \uB2E8\uB9D0\uAE30\uB97C \uC774\uC6A9\uD574\uC8FC\uC138\uC694.")),
                React.createElement("button", { type: "button", className: "js-close", onClick: (e) => qrReaderColes(e) },
                    React.createElement("span", null, "\uB098\uAC00\uAE30"))))));
}
function QrScanRsultPop(props) {
    //props
    const serialD = props.serialD;
    const setSerialD = props.setSerialD;
    const qrSerial = props.qrSerial;
    const qrTimeOut = props.qrTimeOut;
    const setQrSerial = props.setQrSerial;
    const setQrTimeOut = props.setQrTimeOut;
    const video = props.video;
    const setReportList = props.setReportList;
    const setReportLoading = props.setReportLoading;
    const setVideo = props.setVideo;
    const typePop = props.typePop;
    const setTypePop = props.setTypePop;
    const [errorList, setErrorList] = useState([]);
    useEffect(() => {
        var btnCommentClose = document.getElementById("pop-qr-scan");
        btnCommentClose.setAttribute("style", `position: absolute; top:${(window.innerHeight - btnCommentClose.scrollHeight) / 2 + "px"}; left:${(window.innerWidth - btnCommentClose.scrollWidth) / 2 + "px"} `);
    });
    function closeQrPop(e) {
        var btnCommentClose = document.getElementById("pop-qr-scan");
        var body = document.body;
        var dimm = body.querySelector(".dimm");
        if (!CUTIL.isnull(btnCommentClose))
            btnCommentClose.classList.add("hidden");
        if (!CUTIL.isnull(body))
            body.setAttribute("style", "overflow-y: auto;");
        if (!CUTIL.isnull(dimm))
            dimm.setAttribute("style", "display: none; z-index: 11;");
        setSerialD("");
        setQrSerial([]);
    }
    // 시리얼 토글 액션
    function qrClick(item) {
        if (serialD == "") {
            setSerialD(item);
        }
        else if (serialD != item) {
            setSerialD(item);
        }
        else {
            setSerialD("");
        }
    }
    // 오류 확인
    function handleSerialNo(e) {
        setErrorList(errorList.filter((err) => (err.field !== "report")));
        setSerialD(e.target.value);
    }
    // 스캔 후 결과 확인
    function resultOpen(e) {
        return __awaiter(this, void 0, void 0, function* () {
            if (serialD == "") {
                setErrorList([{ field: "report", msg: "시리얼번호를 입력해주세요." }]);
            }
            else {
                setReportLoading(true);
                var btnCommentQr = document.getElementById("pop-qr-scan");
                if (!CUTIL.isnull(btnCommentQr))
                    btnCommentQr.classList.add("hidden");
                const reportInfo = yield HTTPUTIL.API_reportView(serialD);
                setReportLoading(false);
                setReportList(reportInfo);
                var btnCommentClose = document.getElementById("pop-qr-result");
                var body = document.body;
                var dimm = body.querySelector(".dimm");
                if (!CUTIL.isnull(btnCommentClose))
                    btnCommentClose.classList.remove("hidden");
                if (!CUTIL.isnull(body))
                    body.setAttribute("style", "overflow-y: hidden;");
                if (!CUTIL.isnull(dimm))
                    dimm.setAttribute("style", "z-index: 30; display: block;");
                setTypePop("scan");
                setVideo(false);
            }
        });
    }
    // 스캔 다시하기
    function qrSanOpen(e) {
        CUTIL.jsopen_Popup(e);
        setSerialD("");
        setVideo(true);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "pop-qr-scan", className: "popup-layer js-layer layer-out hidden page-detail page-report" },
            React.createElement("div", { className: "popup__head" },
                React.createElement("h1", null,
                    "\uC870\uD68C \uACB0\uACFC ",
                    sessionStorage.getItem("qrCode")),
                React.createElement("button", { className: "btn btn-close js-close", onClick: (e) => closeQrPop(e) },
                    React.createElement("span", { className: "hide" }, "\uB2EB\uAE30"))),
            (qrSerial) &&
                React.createElement("div", { className: "popup__body pb-0" },
                    React.createElement("p", { className: "txt" }, "QR Code Scan \uACB0\uACFC\uC5D0\uC11C \uAE30\uAE30\uC758 \uC2DC\uB9AC\uC5BC \uBC88\uD638\uB97C \uC120\uD0DD\uD558\uC138\uC694."),
                    (!qrTimeOut) &&
                        React.createElement("ul", { className: "select-qr mt-20" },
                            qrSerial.filter((txt, idx) => (idx == 0)).map((qrc, idx) => (React.createElement("li", { key: "qr_" + idx.toString() },
                                React.createElement("a", { href: "#", className: (serialD === qrc[0]) ? "on" : "", onClick: (e) => qrClick(qrc) }, qrc)))),
                            (qrSerial) && qrSerial.filter((ftxt, idx) => (idx == 1)).map((qrc, idx) => (React.createElement("li", { key: "qr__" + idx.toString() },
                                React.createElement("a", { href: "#", className: (serialD === qrc[idx] + qrc[idx + 1]) ? "on" : "", onClick: (e) => qrClick(qrc[0] + qrc[1]) }, qrc[idx] + " " + qrc[idx + 1])))),
                            (qrSerial) && qrSerial.filter((ftxt, idx) => (idx == 2) && (ftxt[0])).map((qrc, idx) => (React.createElement("li", { key: "qr__" + idx.toString() },
                                React.createElement("a", { href: "#", className: (serialD === qrc[0]) ? "on" : "", onClick: (e) => qrClick(qrc[0]) }, qrc[0])))),
                            (qrSerial) && qrSerial.filter((ftxt, idx) => (idx == 2) && (ftxt[1])).map((qrc, idx) => (React.createElement("li", { key: "qr__" + idx.toString() },
                                React.createElement("a", { href: "#", className: (serialD === qrc[1]) ? "on" : "", onClick: (e) => qrClick(qrc[1]) }, qrc[1]))))),
                    (qrTimeOut) &&
                        React.createElement("p", { className: "info" },
                            "QR\uCF54\uB4DC \uC778\uC2DD\uC5D0 \uC2E4\uD328\uD558\uC600\uC2B5\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "\uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694."),
                    React.createElement("ul", { className: "form__input mt-40 mb-0" },
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uC9C1\uC811 \uC785\uB825"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("input", { type: "text", className: (errorList.filter(err => (err.field === "report")).length > 0) ? "input-error" : "", value: serialD, placeholder: "\uAE30\uAE30\uC758 \uC2DC\uB9AC\uC5BC\uBC88\uD638\uB97C \uC9C1\uC811 \uC785\uB825\uD558\uC138\uC694.", onChange: (e) => handleSerialNo(e) }))))),
            React.createElement("div", { className: "popup__footer" },
                React.createElement("button", { type: "button", className: "bg-gray js-open", "data-pop": "pop-qr-open", onClick: (e) => qrSanOpen(e) },
                    React.createElement("span", { "data-pop": "pop-qr-open" }, "\uB2E4\uC2DC\uD558\uAE30")),
                React.createElement("button", { type: "button", onClick: (e) => resultOpen(e) },
                    React.createElement("span", null, "\uD655\uC778"))))));
}
function QrRsultPop(props) {
    //props
    const serialD = props.serialD;
    const setSerialD = props.setSerialD;
    const qrSerial = props.qrSerial;
    const setQrSerial = props.setQrSerial;
    const reportList = props.reportList.IF_RES_DATA;
    const setReportList = props.setReportList;
    const setReportLoading = props.setReportLoading;
    const setVideo = props.setVideo;
    const typePop = props.typePop;
    const setTypePop = props.setTypePop;
    const [errorList, setErrorList] = useState([]);
    useEffect(() => {
        if (typePop == "scan") {
            var btnCommentClose = document.getElementById("pop-qr-result");
            btnCommentClose.setAttribute("style", `position: absolute; top:${(window.innerHeight - btnCommentClose.scrollHeight) / 2 + "px"}; left:${(window.innerWidth - btnCommentClose.scrollWidth) / 2 + "px"} `);
        }
    }, [typePop]);
    function ReflashQrPop(e) {
        if (typePop == "web") {
            var btnCommentOpen = document.getElementById("pop-qr-web");
            if (!CUTIL.isnull(btnCommentOpen))
                btnCommentOpen.classList.remove("hidden");
        }
        else {
            var btnCommentOpen = document.getElementById("pop-qr");
            if (!CUTIL.isnull(btnCommentOpen))
                btnCommentOpen.classList.remove("hidden");
        }
        var btnCommentClose = document.getElementById("pop-qr-result");
        var body = document.body;
        var dimm = body.querySelector(".dimm");
        if (!CUTIL.isnull(btnCommentClose))
            btnCommentClose.classList.add("hidden");
        if (!CUTIL.isnull(body))
            body.setAttribute("style", "overflow-y: hidden;");
        if (!CUTIL.isnull(dimm))
            dimm.setAttribute("style", "z-index: 30; display: block;");
        setSerialD("");
        setQrSerial([]);
        setTypePop("");
    }
    // 결과 완료 액션
    function doneQrPop(e) {
        var btnCommentClose = document.getElementById("pop-qr-result");
        var body = document.body;
        var dimm = body.querySelector(".dimm");
        if (!CUTIL.isnull(btnCommentClose))
            btnCommentClose.classList.add("hidden");
        if (!CUTIL.isnull(body))
            body.setAttribute("style", "overflow-y: auto;");
        if (!CUTIL.isnull(dimm))
            dimm.setAttribute("style", "display: none; z-index: 11;");
        setSerialD("");
        setQrSerial([]);
    }
    // const qrCur = (qrSerial.serialTxt == null) ? null : qrSerial;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "pop-qr-result", className: "popup-layer js-layer layer-out hidden page-detail page-report" },
            React.createElement("div", { className: "popup__head" },
                React.createElement("h1", null,
                    "\uC870\uD68C \uACB0\uACFC ",
                    sessionStorage.getItem("qrCode")),
                React.createElement("button", { className: "btn btn-close js-close" },
                    React.createElement("span", { className: "hide" }, "\uB2EB\uAE30"))),
            React.createElement("div", { className: `popup__body pb-0 ${(reportList == null) ? "nodata" : ""}` },
                React.createElement("p", { className: "nodata__txt" }, "\uB370\uC774\uD130\uB97C \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4."),
                " ",
                React.createElement("div", { className: "tbl-list type2 qr-result" },
                    React.createElement("table", { summary: "\uD30C\uC77C \uBA85,\uC0DD\uC131\uC77C,\uCCA8\uBD80 \uD30C\uC77C \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC131\uC801\uC11C \uD30C\uC77C \uC0C1\uC138 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." },
                        React.createElement("caption", null, "\uD30C\uC77C \uC0C1\uC138 \uB9AC\uC2A4\uD2B8"),
                        React.createElement("colgroup", null,
                            React.createElement("col", { style: {} })),
                        React.createElement("thead", null,
                            React.createElement("tr", null,
                                React.createElement("th", { scope: "col" }, "\uD30C\uC77C \uBA85"),
                                React.createElement("th", { scope: "col" }, "\uC0DD\uC131\uC77C"),
                                React.createElement("th", { scope: "col", className: "txt-center" }, "\uCCA8\uBD80 \uD30C\uC77C"))),
                        React.createElement("tbody", null, (reportList) && reportList.map((report, idx) => (React.createElement("tr", { key: "report_" + idx },
                            React.createElement("td", null,
                                React.createElement("span", null, report.TYPE),
                                React.createElement("span", null, report.CREATION_DATE.substring(0, 4) + "-" + report.CREATION_DATE.substring(4, 6) + "-" + report.CREATION_DATE.substring(6, 8))),
                            React.createElement("td", { className: "btn__tdarea" }, (report.PDF_LINK == null)
                                ? React.createElement("button", { type: "button", className: "btn btn-file", disabled: true },
                                    React.createElement("span", { className: "hide" }, "\uCCA8\uBD80 \uD30C\uC77C"))
                                : React.createElement("a", { href: report.PDF_LINK, target: "_blank", rel: 'noreferrer' },
                                    React.createElement("button", { type: "button", className: "btn btn-file" },
                                        React.createElement("span", { className: "hide" }, "\uCCA8\uBD80 \uD30C\uC77C"))))))))))),
            React.createElement("div", { className: "popup__footer" },
                React.createElement("button", { type: "button", className: "bg-gray", onClick: (e) => ReflashQrPop(e) },
                    React.createElement("span", { "data-pop": "pop-qr-open" }, "\uB2E4\uC2DC\uD558\uAE30")),
                React.createElement("button", { type: "button", className: "js-close", onClick: (e) => doneQrPop(e) },
                    React.createElement("span", null, "\uD655\uC778"))))));
}
